import { render, staticRenderFns } from "./subscribeRecords.vue?vue&type=template&id=608197e7&scoped=true"
import script from "./subscribeRecords.vue?vue&type=script&lang=js"
export * from "./subscribeRecords.vue?vue&type=script&lang=js"
import style0 from "./subscribeRecords.vue?vue&type=style&index=0&id=608197e7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608197e7",
  null
  
)

export default component.exports